// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';

// const JobGrid = () => {
//   const [jobs, setJobs] = useState([]);
//   const [activeFilter, setActiveFilter] = useState('Recent Jobs');
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchJobs = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}job/alljob2?page=1&limit=10`);
//         const data = await response.json();
//         const sortedJobs = Array.isArray(data) ? data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) : [];
//         setJobs(sortedJobs);
//       } catch (error) {
//         console.error("Error fetching jobs:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchJobs();
//   }, []);

//   const getTimeAgo = (date) => {
//     const now = new Date();
//     const postedDate = new Date(date);
//     const monthsAgo = Math.floor((now - postedDate) / (1000 * 60 * 60 * 24 * 30));
//     return `${monthsAgo} month${monthsAgo !== 1 ? 's' : ''} ago`;
//   };

//   const filteredJobs = jobs.filter(job => {
//     if (activeFilter === 'Recent Jobs') return true;
//     return job.workType.toLowerCase() === activeFilter.toLowerCase();
//   }).slice(0, 4);

//   if (loading) return <div className="text-center py-4">Loading...</div>;

//   return (
//     <div className="bg-white p-4 sm:p-6 w-auto flex flex-col flex-wrap">
//       <div className="flex flex-col  sm:flex-row  justify-between items-center mb-4">
//            <div className="flex flex-row flex-wrap sm:flex-row justify-between items-center">
//         <button
//           className={`px-2 mr-20 mb-3  py-2 rounded-l  ${activeFilter === 'Recent Jobs' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-orange-500 hover:text-white transition`}
//           onClick={() => setActiveFilter('Recent Jobs')}
//         >
//           Recent Jobs
//         </button>
       
//           <button
//           className={`px-2 mr-20 mb-3 py-2 ${activeFilter === 'Part-Time' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-orange-500 hover:text-white transition`}
//           onClick={() => setActiveFilter('Part-Time')}
//         >
//           Part time
//         </button>
//         <button
//           className={`px-2 mr-20 mb-3  py-2 rounded-r ${activeFilter === 'Full-Time' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-orange-500 hover:text-white transition`}
//           onClick={() => setActiveFilter('Full-Time')}
//         >
//           Full Time
//         </button>
//         <button
//           className={`px-2  mr-20 mb-3  py-2 rounded-r ${activeFilter === 'Contract' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-orange-500 hover:text-white transition`}
//           onClick={() => setActiveFilter('Contract')}
//         >
//           Contract
//         </button>
//         <button
//           className={`px-2  mr-20 mb-3  py-2 rounded-r ${activeFilter === 'Freelance' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-orange-500 hover:text-white transition`}
//           onClick={() => setActiveFilter('Freelance')}
//         >
//           Freelance
//         </button>
//         <button
//           className={`px-2 mr-20 mb-3   py-2 rounded-r ${activeFilter === 'Remote' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-orange-500 hover:text-white transition`}
//           onClick={() => setActiveFilter('Remote')}
//         >
//           Remote
//         </button>

//       </div>
//       </div>
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
//         {filteredJobs.map((job, index) => (
//           <div key={index} className="bg-gray-50 p-4 border border-gray-200 rounded-lg shadow-sm">
//             <div className="flex items-start justify-between">
//               <div>
//                 <h3 className="text-lg font-semibold text-gray-900">{job.jobTitle}</h3>
//                 <p className="text-sm text-gray-600">{job.employer?.name || 'Unknown Employer'}</p>
//               </div>
//               <span className="text-sm text-gray-500">{job.workType}</span>
//             </div>
//             <div className="mt-2 text-sm text-gray-600">
//               <p><span className="text-orange-500">★</span> {job.localGovernment}, {job.state}</p>
//               <p>Experience Level: {job.experienceLength}</p>
//               <p>Posted: {getTimeAgo(job.createdAt)}</p>
//             </div>
//             <div className="mt-2 text-sm text-gray-600 flex justify-between">
//               <span>Salary: {job.salary} {job.currency}</span>
//               <Link to="/jobs" className="text-orange-500 hover:underline">Apply now</Link>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default JobGrid;













import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const JobGrid = () => {
  const [jobs, setJobs] = useState([]);
  const [activeFilter, setActiveFilter] = useState('Recent Jobs');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}job/alljob2?page=1&limit=10`);
        const data = await response.json();
        const sortedJobs = Array.isArray(data) ? data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) : [];
        setJobs(sortedJobs);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchJobs();
  }, []);

  const getTimeAgo = (date) => {
    const now = new Date();
    const postedDate = new Date(date);
    const monthsAgo = Math.floor((now - postedDate) / (1000 * 60 * 60 * 24 * 30));
    return `${monthsAgo} month${monthsAgo !== 1 ? 's' : ''} ago`;
  };

  const filteredJobs = jobs
    .filter(job => {
      if (activeFilter === 'Recent Jobs') return true;
      return job.workType.toLowerCase() === activeFilter.toLowerCase();
    })
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .slice(0, 4);

  if (loading) return <div className="text-center py-4">Loading...</div>;

  return (
    <div className="bg-white p-4 sm:p-6 w-auto flex flex-col flex-wrap">
      <div className="flex flex-col sm:flex-row justify-between items-center mb-4">
        <div className="flex flex-row flex-wrap sm:flex-row justify-between items-center">
          <button
            className={`px-2 mr-20 mb-3 py-2 rounded-l ${activeFilter === 'Recent Jobs' ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-green-500 hover:text-white transition`}
            onClick={() => setActiveFilter('Recent Jobs')}
          >
            Recent Jobs
          </button>
          <button
            className={`px-2 mr-20 mb-3 py-2 ${activeFilter === 'Part-Time' ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-green-500 hover:text-white transition`}
            onClick={() => setActiveFilter('Part-Time')}
          >
            Part time
          </button>
          <button
            className={`px-2 mr-20 mb-3 py-2 rounded-r ${activeFilter === 'Full-Time' ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-green-500 hover:text-white transition`}
            onClick={() => setActiveFilter('Full-Time')}
          >
            Full Time
          </button>
          <button
            className={`px-2 mr-20 mb-3 py-2 rounded-r ${activeFilter === 'Contract' ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-green-500 hover:text-white transition`}
            onClick={() => setActiveFilter('Contract')}
          >
            Contract
          </button>
          <button
            className={`px-2 mr-20 mb-3 py-2 rounded-r ${activeFilter === 'Freelance' ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-green-500 hover:text-white transition`}
            onClick={() => setActiveFilter('Freelance')}
          >
            Freelance
          </button>
          <button
            className={`px-2 mr-20 mb-3 py-2 rounded-r ${activeFilter === 'Remote' ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-green-500 hover:text-white transition`}
            onClick={() => setActiveFilter('Remote')}
          >
            Remote
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {filteredJobs.map((job, index) => (
          <div key={index} className="bg-gray-50 p-4 border border-gray-200 rounded-lg shadow-sm">
            <div className="flex items-start justify-between">
              <div>
                <h3 className="text-lg font-semibold text-gray-900">{job.jobTitle}</h3>
                <p className="text-sm text-gray-600">{job.employer?.name || 'Unknown Employer'}</p>
              </div>
              <span className="text-sm text-gray-500">{job.workType}</span>
            </div>
            <div className="mt-2 text-sm text-gray-600">
              <p><span className="text-green-500">★</span> {job.localGovernment}, {job.state}</p>
              <p>Experience Level: {job.experienceLength}</p>
              <p>Posted: {getTimeAgo(job.createdAt)}</p>
            </div>
            <div className="mt-2 text-sm text-gray-600 flex justify-between">
              <span>Salary: {job.salary} {job.currency}</span>
              <Link to="/jobs" className="text-green-500 hover:underline">Apply now</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default JobGrid;

